import React from "react";
import fondofooter from "../../assets/image/stella/fondofooter.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faX} from "@fortawesome/free-solid-svg-icons";
import Buy from "../../widgets/buy";

const Section3 = () => {
    return (
        <section id="paneles" className="relative">
            <div
                className="absolute inset-0 bg-contain bg-bottom bg-repeat-x opacity-50 z-0"
                style={{
                    backgroundImage: `url(${fondofooter})`,
                }}></div>
            <div className="container relative px-4 pb-[140px]">
                <div className="text-center mb-10">
                    <div
                        className="relative -bottom-5 -left-8 gray-text-fill-stroke-1 font-bold -tracking-[6px] text-[66px] md:text-[90px] leading-none text-transparent">REVENTA
                    </div>
                    <h2 className="text-[36px] leading-[42px] md:text-[45px] md:leading-none font-semibold group">Planes
                        de <span className="text-[#FF9501] group-hover:text-black">Paneles</span> de Stella TV</h2><p
                    className="max-w-[480px] mx-auto mt-3 opacity-90 text-[#FFFFFFB3]">Seleccione su plan para ser
                    un <span className="text-active font-bold">revendedor oficial de Stella TV</span>, mejores precios
                    del mercado con pagos seguros en cualquier parte del mundo. Adquiera ya mismo un <strong>panel de
                        StellaTV</strong>.</p></div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-[80px] md:px-10">
                    <div className="rounded-[30px] border-5 border-primari bg-[#1d1d1d] overflow-hidden intersect:animate-in slide-in-from-left intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">PANEL BRONCE</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">60</span>
                                <div className="text-sm tracking-wide font-normal text-center">15 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>4$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faX}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>No Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="rounded-[30px] border-5 border-primari bg-gradient-to-r from-[#eeb500] to-[#d62d08] overflow-hidden intersect:animate-in slide-in-from-bottom intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">PANEL PLATA</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">200</span>
                                <div className="text-sm tracking-wide font-normal text-center">50 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>4$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faX}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>No Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="rounded-[30px] border-5 border-primari bg-[#1d1d1d] overflow-hidden intersect:animate-in slide-in-from-right intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">SUPER PANEL</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">350</span>
                                <div className="text-sm tracking-wide font-normal text-center">100 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3.5$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="rounded-[30px] border-5 border-primari bg-[#1d1d1d] overflow-hidden intersect:animate-in slide-in-from-left intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">SUPER PANEL PLATA</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">780</span>
                                <div className="text-sm tracking-wide font-normal text-center">300 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>2.6$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="rounded-[30px] border-5 border-primari bg-gradient-to-r from-[#eeb500] to-[#d62d08] overflow-hidden intersect:animate-in slide-in-from-bottom intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">SUPER PANEL ORO</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">1100</span>
                                <div className="text-sm tracking-wide font-normal text-center">500 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>2.2$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="rounded-[30px] border-5 border-primari bg-[#1d1d1d] overflow-hidden intersect:animate-in slide-in-from-right intersect-once duration-1250">
                        <div className="flex flex-col items-center justify-center h-[74px]"><h3
                            className="text-2xl font-semibold m-0 tracking-wide">PANEL ADMIN</h3></div>
                        <div className="flex flex-col items-center bg-[#1d1d1d]">
                            <div className="my-10 text-primari font-bold leading-none"><span
                                className="text-[22px] align-top">$</span><span className="text-[72px]">2050</span>
                                <div className="text-sm tracking-wide font-normal text-center">1000 CRÉDITOS</div>
                            </div>
                            <ul className="w-full px-[30px] list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>2.05$ Cada Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>3-4 Conexiones por Crédito</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-sm text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Puede Vender Panel</span></div>
                                </li>
                            </ul>
                            <div className="my-[30px] text-white">
                                <Buy/>
                                <div className="text-center text-xs opacity-80 mt-2">*Pagos Seguros</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Section3;
